import Vue from 'vue';
import _ from 'lodash';
import AccountInvestigatorApi from '../../api/AccountInvestigatorApi';
import InputOnboardingApi from '../../api/InputOnboardingApi';
import consts from '../utilities/constants';

const state = {
  accountQuestions: [],
  showDiscountPromotion: false,
};

const getters = {
  noIncludedAccounts: state => _.isEmpty(_.filter(state.accountQuestions, { isIncluded: true })),
};

const actions = {
  async fetchAccounts({ commit, state }) {
    const accountQuestions = await AccountInvestigatorApi.fetchAccountInvestigationOnboardingQuestions();
    const defaultIncluded = accountQuestions.length === 1;
    const accountQuestionsWithDefault = _.map(accountQuestions, accountQuestion => {
      return { isIncluded: defaultIncluded, ...accountQuestion };
    });
    if (_.some(accountQuestions, question => question.source === 'discountApi' &&
      !_.find(state.accountQuestions, { account: question.account }))) {
      commit('setShowDiscountPromotion', true);
    }
    commit('setAccountQuestions', accountQuestionsWithDefault);
  },
  async saveAccountInputs({ state }) {
    const accountInput = _.map(state.accountQuestions, _extractAccountInput);
    await InputOnboardingApi.saveInputs({ [consts.INPUT_TYPES.ACCOUNT_INPUT]: accountInput });
  },
};

const mutations = {
  setAccountQuestions(state, accountQuestions) {
    state.accountQuestions = accountQuestions; // eslint-disable-line
  },
  setShowDiscountPromotion(state, showDiscountPromotion) {
    state.showDiscountPromotion = showDiscountPromotion; // eslint-disable-line
  },
  toggleAccountIsIncluded(state, account) {
    const accountQuestion = _.find(state.accountQuestions, { account });
    const isIncluded = !accountQuestion.isIncluded;
    Vue.set(accountQuestion, 'isIncluded', isIncluded);
  },
};

function _extractAccountInput(accountQuestion) {
  return {
    account: accountQuestion.account,
    accountStatus: accountQuestion.isIncluded ? 'include' : 'exclude',
    source: accountQuestion.source,
    sourceType: accountQuestion.sourceType,
  };
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/accountInvestigationOnboarding.js